module.exports = __webpack_public_path__ + "static/media/Pokemon_logo.f234edf1.png";